import React from 'react';
import * as THREE from 'three';

interface Props {
  readonly width: number;
  readonly height: number;
  readonly depth: number;
}

export default (props: Props) => (
  <lineSegments position={[props.width / 2, props.height / 2, props.depth / 2]}>
    <edgesGeometry attach="geometry" args={[new THREE.BoxGeometry(props.width, props.height, props.depth)]} />
    <lineBasicMaterial attach="material" linewidth={2} color={0xffff00} />
  </lineSegments>
);
